__turbopack_context__.v({
  "caption": "ExBtWG_caption",
  "card": "ExBtWG_card",
  "cardImage": "ExBtWG_cardImage",
  "cardOverlay": "ExBtWG_cardOverlay",
  "cardsContainer": "ExBtWG_cardsContainer",
  "contentContainer": "ExBtWG_contentContainer",
  "description": "ExBtWG_description",
  "mobileCaption": "ExBtWG_mobileCaption",
  "mobileCarouselContainer": "ExBtWG_mobileCarouselContainer",
  "mobileCarouselWrapper": "ExBtWG_mobileCarouselWrapper",
  "mobileEmbla": "ExBtWG_mobileEmbla",
  "mobileEmblaContainer": "ExBtWG_mobileEmblaContainer",
  "mobileEmblaSlide": "ExBtWG_mobileEmblaSlide",
  "mobileImage": "ExBtWG_mobileImage",
  "mobileImageWrapper": "ExBtWG_mobileImageWrapper",
  "mobileSubtitle": "ExBtWG_mobileSubtitle",
  "mobileTextContainer": "ExBtWG_mobileTextContainer",
  "mobileTextWrapper": "ExBtWG_mobileTextWrapper",
  "mobileTitle": "ExBtWG_mobileTitle",
  "sleepFeatureCardsSection": "ExBtWG_sleepFeatureCardsSection",
  "stickyContainer": "ExBtWG_stickyContainer",
  "stickyWrapper": "ExBtWG_stickyWrapper",
  "textContainer": "ExBtWG_textContainer",
  "textWrapper": "ExBtWG_textWrapper",
  "title": "ExBtWG_title",
  "whiteOverlay": "ExBtWG_whiteOverlay",
});
